var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('advertisement-top-banner'), [_vm.showBusinesKeyPoints ? _c('Featured', {
    attrs: {
      "features": [{
        image: 'img/delivery-truck.svg',
        title: 'features.freeShipping.title',
        description: 'features.freeShipping.description'
      }, {
        image: '/img/headphones.svg',
        title: 'features.customerSupport.title',
        description: 'features.customerSupport.description'
      }, {
        image: '/img/shopping-bag.svg',
        title: 'features.securePayment.title',
        description: 'features.securePayment.description'
      }, {
        image: '/img/package.svg',
        title: 'features.moneyBack.title',
        description: 'features.moneyBack.description'
      }]
    }
  }) : _vm._e()], _vm.$store.state.core.websiteMode === 'store' ? _c('div', [_c('store')], 1) : _c('div', [_c('product')], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }